import React from 'react'

interface HandleSaleStock {
  page : Number,
  setPage : Function,
  stock: Number,
  setStock: Function,
  stockUnit: Number,
  setStockUnit: Function,
  price: Number,
  setPrice: Function
  basePrice: Number,
  setBasePrice: Function,
  payType: Number,
  sePayType: Function,
  order: Object,
  setOrder: Function
}
const HandleSaleStock = React.createContext<HandleSaleStock | any>(1);


export {HandleSaleStock}
